<div
  class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto eol-module"
  style="min-height: 100vh;"
>
  <div style="padding-left: 15px" class="col-12 no-gutters">
    <app-layout-header
      [isEolModule]="true"
      class="col-12 no-gutters"
    ></app-layout-header>
  </div>
  <div class="mt-3 col-12 px-0">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer-layout></app-footer-layout>
